var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass:
        "btn btn-sm single-share-button d-flex justify-content-center align-items-center",
      attrs: {
        title: _vm.$translate("modeherz::SocialMediaClient.socialMediaShare"),
      },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.shareViaApi($event)
        },
      },
    },
    [
      _vm._v(
        "\n  " +
          _vm._s(
            _vm.$translate("modeherz::SocialMediaClient.socialMediaShare")
          ) +
          "\n  "
      ),
      _c("icon", {
        staticClass: "default-float ml-3",
        attrs: { icon: "share-alt", loading: _vm.isLoading },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }